import {Redirect, Route, Switch} from 'react-router-dom';

import ProfileEdit from "./pages/Profile/Edit";

import Users from "./pages/User/Users";
import {useUser} from "./Components/UserProvider";
import Chat from './pages/Chat/Chat';
import Mentors from './pages/Mentor/Mentors';
import Dashboard from './pages/Dashboard';
import Mentees from './pages/Mentee/Mentees';
import Settings from './pages/Profile/Settings';

export default function Router() {
    const user = useUser();

    return <Switch>
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/chat" component={Chat} />
        { user.type === 512 && <Route path="/user" component={Users}/> }
        <Route path="/profile" component={ProfileEdit} />
        <Route path="/mentor" component={Mentors} />
        <Route path="/mentee" component={Mentees} />
        <Route path="/settings" component={Settings} />
        <Redirect from="/" to="/dashboard"/>
    </Switch>;
}
